import { Reveal, SectionLabel } from "./ui";

export default function Problem({ problems = [], index, appr }) {
  return (
    <section style={appr?.style} className={`relative text-white py-20 lg:py-28 mf-grain overflow-hidden ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container relative">
        <Reveal>
          <SectionLabel index={index}>Was Betreiber uns berichten</SectionLabel>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-head font-light tracking-tight text-[1.875em] md:text-[1.125em] lg:text-[2.6em] leading-tight mt-6 max-w-3xl">
            Drei Situationen, die wir <span className="text-[var(--mf-red)] font-medium">immer wieder hören</span>.
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {problems.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="bg-[var(--mf-ink)] h-full p-8 lg:p-10" data-testid={`problem-${i}`}>
                <div className="font-head text-5xl font-light text-[var(--mf-red)] leading-none">“</div>
                <p className="mt-4 text-[1.125em] leading-relaxed text-white/85 font-light">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
